<div>
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="acceptedSignUpMentors()"></grid-content>
</div>